import(/* webpackMode: "eager" */ "/builds/magic.ai/frontend/magicsquare/apps/launchpad/app/error.tsx");
